var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71915 9.66319C8.45603 9.54723 8.14923 9.66944 8.03586 9.93307C7.50131 11.1644 6.28607 11.96 4.93978 11.96C3.0761 11.96 1.55978 10.4437 1.55978 8.58003C1.55978 7.37154 2.21082 6.24991 3.2581 5.6514C3.50823 5.50944 3.59456 5.19173 3.45206 4.94211C3.3101 4.69252 2.99186 4.60411 2.74278 4.74866C1.37153 5.53125 0.519775 6.99921 0.519775 8.58003C0.519775 11.0173 2.50253 13 4.93978 13C6.70102 13 8.29066 11.9585 8.98953 10.347C9.10394 10.0839 8.98329 9.77758 8.71915 9.66319Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.443 10.2071C12.3358 9.9398 12.0353 9.8098 11.767 9.91692L10.989 10.2284L9.857 6.60504C9.78887 6.38767 9.58763 6.24 9.35987 6.24H5.64604L5.48432 5.2H7.53987C7.82742 5.2 8.05987 4.96755 8.05987 4.68C8.05987 4.39245 7.82742 4.16 7.53987 4.16H5.32312L5.05428 2.42788C5.44949 2.20429 5.71987 1.78567 5.71987 1.3C5.71987 0.582918 5.13696 0 4.41987 0C3.70332 0 3.11987 0.582918 3.11987 1.3C3.11987 1.87563 3.49842 2.35925 4.01791 2.52979L4.68612 6.83955C4.72565 7.0933 4.94353 7.28 5.19987 7.28H8.97767L10.1633 11.075C10.2069 11.2133 10.3057 11.3272 10.4368 11.3895C10.507 11.4233 10.584 11.44 10.6599 11.44C10.7254 11.44 10.7909 11.428 10.8533 11.4031L12.1533 10.8831C12.4201 10.7765 12.5495 10.4738 12.443 10.2071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisability);
export default __webpack_public_path__ + "static/media/Disability.19f70122d906b3a6326e786e8c100678.svg";
export { ForwardRef as ReactComponent };